"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepperContext = void 0;

var react_1 = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var SzTypographie_1 = __importDefault(require("../SzTypographie/SzTypographie"));

var SzTypographie_2 = __importDefault(require("../SzTypographie/SzTypographie"));

var ProgressBar_1 = __importDefault(require("react-bootstrap/ProgressBar"));

require("./SzStepper.scss");

var __1 = require("../..");

var defaultValues = {
  activeStep: 0,
  header: [],
  variant: 'empty',
  displayProgress: true
};
exports.StepperContext = react_1.createContext(defaultValues);

var SzStepper = function SzStepper(props) {
  return react_1.default.createElement(exports.StepperContext.Provider, __assign({
    value: props
  }, props));
};

var Step = function Step(props) {
  var activeStep = react_1.useContext(exports.StepperContext).activeStep;

  var stepClasses = function stepClasses(key) {
    return classnames_1.default('step sz-body-stepper bg-white rounded', 'sz-body-stepper__step', props.className || '', {
      active: key === activeStep
    });
  };

  return react_1.default.createElement("div", {
    className: stepClasses(props.index)
  }, props.children);
};

var Header = function Header(props) {
  var _a = react_1.useContext(exports.StepperContext),
      header = _a.header,
      activeStep = _a.activeStep,
      variant = _a.variant;

  var stepClasses = function stepClasses(key) {
    return classnames_1.default('sz-header-stepper__step step position-relative h-100', {
      'pl-3 d-flex align-items-center w-50': variant !== 'rounded',
      'sz-step-rounded text-center mx-2': variant === 'rounded',
      untouched: key > activeStep && variant === 'rounded',
      underline: key < activeStep || key === activeStep,
      active: key === activeStep
    });
  };

  if (variant === 'rounded') {
    return react_1.default.createElement(HeaderRounded, __assign({
      stepClasses: stepClasses
    }, props));
  }

  if (variant === 'simple') {
    return react_1.default.createElement(HeaderSimple, __assign({}, props));
  }

  return react_1.default.createElement("div", {
    className: "sz-header-stepper d-flex bg-white rounded " + (props.className || '')
  }, header.map(function (item, key) {
    return react_1.default.createElement("div", {
      key: key,
      className: stepClasses(key)
    }, react_1.default.createElement(SzTypographie_2.default, {
      tag: "span",
      weight: "bold",
      className: "mr-2"
    }, key + 1, "."), item);
  }));
};

var HeaderSimple = function HeaderSimple(props) {
  var _a = react_1.useContext(exports.StepperContext),
      header = _a.header,
      activeStep = _a.activeStep,
      displayProgress = _a.displayProgress;

  var progressPurcent = 100 / header.length * (activeStep + 1);
  return react_1.default.createElement("div", {
    className: "sz-header-stepper d-flex bg-white rounded p-3 align-items-center " + (props.className || '')
  }, react_1.default.createElement("div", {
    className: 'w-50'
  }, react_1.default.createElement(SzTypographie_1.default, {
    className: "m-0"
  }, header[activeStep])), displayProgress && react_1.default.createElement("div", {
    className: "d-flex ml-auto pt-4 position-relative"
  }, react_1.default.createElement(SzTypographie_2.default, {
    className: "m-0 w-100 position-absolute simple-title text-uppercase text-nowrap"
  }, "\xE9tape " + (activeStep + 1) + "/" + header.length), react_1.default.createElement(ProgressBar_1.default, {
    now: progressPurcent,
    className: "stepper-bar",
    variant: "success"
  })));
};

var HeaderRounded = function HeaderRounded(_a) {
  var stepClasses = _a.stepClasses,
      className = _a.className;

  var _b = react_1.useContext(exports.StepperContext),
      header = _b.header,
      activeStep = _b.activeStep;

  var captionClasses = 'd-flex sz-border-1 font-weight-bold mx-auto';
  var progressPurcent = 100 / header.length * (activeStep + 1);
  var iter = 0;
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
    className: classnames_1.default('sz-header-stepper d-none d-md-flex align-items-center justify-content-center', className)
  }, header.map(function (item, key) {
    var index = key + 1;

    var itemClasses = function itemClasses(key) {
      return classnames_1.default('border rounded-circle', {
        'border-primary-brand': key < activeStep || key === activeStep,
        'border-blue-3': key > activeStep
      });
    };

    var itemString = typeof item === 'string';
    var number = itemString ? iter++ + 1 : iter;
    var iconVariant = 'line';
    if (!itemString) iconVariant = item['icon']['variant'] === 'bold' ? 'bold' : 'line';
    return react_1.default.createElement("div", {
      key: key,
      className: stepClasses(key)
    }, index === header.length ? react_1.default.createElement(SzTypographie_2.default, {
      variant: "caption",
      className: captionClasses + " " + itemClasses(key)
    }, react_1.default.createElement(__1.SzIcon, {
      variant: "bold",
      icon: "check-circle-1"
    })) : react_1.default.createElement(SzTypographie_2.default, {
      variant: "caption",
      className: captionClasses + " " + (itemString ? itemClasses(key) : 'icon')
    }, itemString ? number : react_1.default.createElement(__1.SzIcon, {
      icon: item['icon']['name'],
      variant: iconVariant,
      className: "" + (item['icon']['className'] && item['icon']['className'])
    })), react_1.default.createElement(SzTypographie_2.default, {
      tag: "span",
      className: "d-block my-2 px-3"
    }, itemString ? item : item['title']));
  })), react_1.default.createElement("div", {
    className: classnames_1.default('sz-header-stepper d-md-none', className)
  }, react_1.default.createElement(SzTypographie_2.default, {
    weight: "regular",
    variant: "caption",
    className: "mb-1 mt-3 ml-3 sz-header-stepper_title-progress-bar"
  }, "Etape " + (activeStep + 1) + ": ", react_1.default.createElement(SzTypographie_2.default, {
    tag: "span",
    weight: "medium"
  }, typeof header[activeStep] === 'string' ? header[activeStep] : header[activeStep]['title'])), react_1.default.createElement(ProgressBar_1.default, {
    now: progressPurcent,
    className: "sz-stepper_progress-bar-rounded mx-3"
  })));
};

SzStepper.SzStep = Step;
SzStepper.SzHeader = Header;
exports.default = SzStepper;